
































































import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import { Form } from "element-ui";
import { axios } from "../../plugins";

const AutoForm = {
  metadata: { name: "", namespace: "" },
  spec: {
    scaleTargetRef: {
      apiVersion: "apps/v1",
      kind: "",
      name: ""
    },
    minReplicas: undefined,
    maxReplicas: undefined,
    metrics: [
      {
        type: "Resource",
        resource: {
          name: "memory",
          target: { type: "AverageValue", averageValue: "" }
        }
      },
      {
        type: "Resource",
        resource: {
          name: "cpu",
          target: { type: "Utilization", averageUtilization: undefined }
        }
      }
    ]
  },
  apiVersion: "autoscaling/v2beta2",
  kind: "HorizontalPodAutoscaler"
};

export default Vue.extend({
  name: "EditScaling",
  props: { type: { type: String }, projectId: { type: String } },
  data() {
    const validatorLimit = (rule: any, value: string, callback: any) => {
      if (
        // @ts-ignore
        this.ruleForm.spec.metrics[0].resource.target.averageValue ||
        // @ts-ignore
        this.ruleForm.spec.metrics[1].resource.target.averageUtilization
      ) {
        callback();
      } else {
        callback("不能同时为空");
      }
    };
    return {
      dialog: false,
      isEdit: false,
      loading: false,
      ruleForm: JSON.parse(JSON.stringify(AutoForm)) as typeof AutoForm,
      rules: {
        "metadata.name": [{ required: true, type: "string" }],
        "spec.minReplicas": [
          {
            required: true,
            type: "number",
            min: 1,
            max: 10000,
            pattern: /^\d+$/
          }
        ],
        "spec.maxReplicas": [
          {
            required: true,
            type: "number",
            min: 1,
            max: 10000,
            pattern: /^\d+$/
          }
        ],
        "spec.metrics.0.resource.target.averageValue": [
          { type: "string", pattern: /^\d+Mi$/, trigger: "change" },
          { validator: validatorLimit, trigger: "blur" }
        ],
        "spec.metrics.1.resource.target.averageUtilization": [
          { pattern: /^\d*$/, trigger: "change" },
          { validator: validatorLimit, trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    averageValue: {
      get() {
        // @ts-ignore
        if (!this.ruleForm.spec.metrics[0].resource.target.averageValue) {
          return undefined;
        } else {
          // @ts-ignore

          return this.ruleForm.spec.metrics[0].resource.target.averageValue.slice(
            0,
            -2
          );
        }
      },
      set(val: number) {
        if (val) {
          // @ts-ignore
          this.ruleForm.spec.metrics[0].resource.target.averageValue = `${val}Mi`;
        } else {
          // @ts-ignore
          this.ruleForm.spec.metrics[0].resource.target.averageValue = "";
        }
      }
    },
    ...mapState("LoginInfo", ["userinfo", "project"]),
    ...mapGetters("LoginInfo", ["tenant"])
  },
  methods: {
    show(data: any, isEdit: boolean) {
      if (isEdit) {
        // @ts-ignore
        this.ruleForm = JSON.parse(JSON.stringify(data));
        // @ts-ignore
        if ((this.ruleForm as typeof AutoForm).spec.metrics.length < 2) {
          if (
            // @ts-ignore
            (this.ruleForm as typeof AutoForm).spec.metrics[0].resource.name ===
            "memory"
          ) {
            // @ts-ignore
            (this.ruleForm as typeof AutoForm).spec.metrics.push({
              type: "Resource",
              resource: {
                name: "cpu",
                target: { type: "Utilization", averageUtilization: undefined }
              }
            });
          } else {
            // @ts-ignore
            (this.ruleForm as typeof AutoForm).spec.metrics.unshift({
              type: "Resource",
              resource: {
                name: "memory",
                target: { type: "AverageValue", averageValue: "" }
              }
            });
          }
        }
      } else {
        // @ts-ignore
        this.ruleForm.metadata.name = data;
        // @ts-ignore
        this.ruleForm.spec.scaleTargetRef.name = data;
        // @ts-ignore
        this.ruleForm.spec.scaleTargetRef.kind = this.type;
      }
      // @ts-ignore
      this.isEdit = isEdit;
      // @ts-ignore
      this.dialog = true;
    },
    quit() {
      // @ts-ignore
      this.ruleForm = JSON.parse(JSON.stringify(AutoForm));
      this.$refs.ruleForm && (this.$refs.ruleForm as Form).clearValidate();
      // @ts-ignore
      this.dialog = false;
    },
    submit() {
      (this.$refs.ruleForm as Form).validate(vakid => {
        if (vakid) {
          // @ts-ignore
          this.loading = true;
          // @ts-ignore
          if (this.isEdit) {
            // @ts-ignore
            this.edit();
          } else {
            // @ts-ignore
            this.create();
          }
        }
      });
    },
    edit() {
      // @ts-ignore
      const data = JSON.parse(JSON.stringify(this.ruleForm)) as typeof AutoForm;

      data.spec.metrics.forEach((item, index) => {
        if (
          !item.resource.target.averageValue &&
          !item.resource.target.averageUtilization
        ) {
          data.spec.metrics.splice(index, 1);
        }
      });
      axios
        // @ts-ignore
        .put(`/autoscaling/${this.projectId}`, data)
        .then(() => {
          // @ts-ignore
          this.quit();
          // @ts-ignore
          this.$message.success("伸缩策略编辑成功！");
        })
        .finally(() => {
          // @ts-ignore
          this.loading = false;
        });
    },
    create() {
      // @ts-ignore
      const data = JSON.parse(JSON.stringify(this.ruleForm)) as typeof AutoForm;
      data.spec.metrics.forEach((item, index) => {
        if (
          !item.resource.target.averageValue &&
          !item.resource.target.averageUtilization
        ) {
          data.spec.metrics.splice(index, 1);
        }
      });
      // @ts-ignore
      data.metadata.namespace = `${this.tenant.code}-${this.project.projectName}`;
      axios
        // @ts-ignore
        .post(`/autoscaling/${this.projectId}`, data)
        .then(() => {
          // @ts-ignore
          this.quit();
          // @ts-ignore
          this.$message.success("伸缩策略创建成功！");
        })
        .finally(() => {
          // @ts-ignore
          this.loading = false;
        });
    }
  }
});
